import { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { CreditSelectors } from "Redux/CreditRedux";

export default function LowCreditsWarning() {
  const credits = useSelector(CreditSelectors.getCredits);
  const isLowCredits = useSelector(CreditSelectors.isLowCredits);
  const [isDismissed, setIsDismissed] = useState(false);

  // Don't show if not low or dismissed
  if (!isLowCredits || isDismissed || !credits) return null;

  const availableCredits = credits?.available || 0;

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm text-amber-800">
          <span aria-hidden="true">⚠️</span>
          <span>
            Running low on credits! You have <strong>{availableCredits}</strong> credits left.
          </span>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/plans"
            className="px-3 py-1.5 text-xs font-medium text-white bg-amber-600 rounded-lg hover:bg-amber-700 transition-colors min-h-[36px] flex items-center"
          >
            Upgrade
          </Link>
          <button
            onClick={() => setIsDismissed(true)}
            className="w-8 h-8 flex items-center justify-center text-amber-600 hover:text-amber-800 hover:bg-amber-100 rounded-lg transition-colors"
            aria-label="Dismiss low credits warning"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
